import Product from "../../../../../@types/Product";

const Batteries: Product[] = [
    {
        id: 1,
        name: 'ECO Lithium 105AH',
        sku: 'A-051105-03-G3',
        price: 0,
        retailPrice: 0.00,
        visible: false
    },
    {
        id: 2,
        name: 'ECO Lithium 60AH',
        sku: 'A-051060-05-G3',
        price: 0,
        retailPrice: 0.00,
        visible: false
    },
    {
        id: 3,
        name: 'ECO Lithium GEN3 160AH',
        sku: 'A-051160-06-G3',
        price: 0,
        retailPrice: 0.00,
        visible: false,
    }
]

export default Batteries;